import axios from 'axios';
import authHeader from './auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/league/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/league/';

class LeagueService {
  getAllLeaguesByClient(clientId) {
    return axios.get(API_URL  + "client/" + clientId);
  }

  getAllLeagues() {
    return axios.get(API_URL );
  }

  getYearsByLeagueId(leagueId){
    return axios.get(`${API_URL}${leagueId}/years` );
  }

  getLeague(leagueId){
    return axios.get(`${API_URL}${leagueId}` );
  }

  getLeaguesBySeasons(seasonIds) {
    return axios.get(API_URL + "seasons/" + seasonIds);
  }

  getSoSInfo(leagueId,year){
    return axios.get(`${API_URL}${leagueId}/year/${year}/sos`);
  }

  postLeague(league){
    return axios.post(`${API_URL}`,league);
  }

  getPlayerInsights(seasonId, gameH2HId = 1, accumulation = "Total") {
    return axios.get(API_URL + "player-insights/season/" + seasonId + "/template/" + gameH2HId + "/accumulation/" + accumulation);
  }

  getTeamInsights(seasonId) {
    return axios.get(API_URL + "team-insights/season/" + seasonId);
  }

}

export default new LeagueService();



// WEBPACK FOOTER //
// ./src/services/league.service.js